import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { fieldUserMappingSchemaObject } from '../fieldUserMappingSchema';
import { validateProperty } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

const screenCode = 'FIELDUSERMAPPING';

export function FieldUserMappingAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Field User Mapping")
    const [groups, setGroups] = useState()
    const [operationEntities, setOperationEntities] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [devisions, setDevisions] = useState()
    const [allowDivisions, setAllowDivisions] = useState()
    const [users, setUsers] = useState()
    const contentRowNames = ["divisionName", "userName"]
    const [isViewTable, setIsViewTable] = useState(true);
    const [details, setDetails] = useState({
        dataArray: []
    });
    const [fieldUserMapping, setFieldUserMapping] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        userID: "0",
        allowDivisionID: "0"
    });
    const [buttonName, setButtonName] = useState("Add");
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    const [pageProperties, setPageProperties] = useState({
        title: 'Add Field User Mapping',
        submitButtonName: 'Save'
    })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(fieldUserMappingSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [fieldUserMapping.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions()
        )
    }, [fieldUserMapping.operationEntityID])

    useEffect(() => {
        trackPromise(
            getAllowDivisions()
        )
    }, [fieldUserMapping.operationEntityID, fieldUserMapping.collectionPointID])

    useEffect(() => {
        trackPromise(
            getUsers()
        )
    }, [fieldUserMapping.collectionPointID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITFIELDUSERMAPPING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        if (data && edit) {
            setTitle("Edit Field User Mapping");
            setFieldUserMapping(data);
            setButtonName("Update");
        } else {
            setTitle("Add Field User Mapping");
            var token = tokenService.getUserDetailsFromTokenV2();
            if (token.operationEntities.length > 0) {
                var estateArray = [];
                for (let item of Object.entries(token.operationEntities)) {
                    estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
                }
                setMultipleEstates(estateArray)
            }
            setPermissions({
                ...permissionList,
                isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
                isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
            });
            setFieldUserMapping({
                ...fieldUserMapping,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getAllGroups()
        )
    }

    async function getOperationEntities() {
        const operationEntityList = await services.getOperationEntitiesByGroupForDropDown(fieldUserMapping.groupID);
        setOperationEntities(operationEntityList);
    }

    function handleGroupChange(target) {
        validateInputs(target);
        setFieldUserMapping({
            ...fieldUserMapping,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0',
            userID: '0',
            allowDivisionID: '0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);
        setFieldUserMapping({
            ...fieldUserMapping,
            operationEntityID: target.value,
            collectionPointID: '0',
            userID: '0',
            allowDivisionID: '0'
        })
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);
        setFieldUserMapping({
            ...fieldUserMapping,
            collectionPointID: target.value,
            userID: '0',
            allowDivisionID: '0'
        })
    }

    function handleUserChange(target) {
        validateInputs(target);
        setFieldUserMapping({
            ...fieldUserMapping,
            userID: target.value
        })
    }

    function handleAllowDivisionChange(target) {
        validateInputs(target);
        setFieldUserMapping({
            ...fieldUserMapping,
            allowDivisionID: target.value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, fieldUserMappingSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error)
    }


    async function handleSave() {
        const { error } = schema.validate({
            groupID: parseInt(fieldUserMapping.groupID),
            operationEntityID: parseInt(fieldUserMapping.operationEntityID),
            collectionPointID: parseInt(fieldUserMapping.collectionPointID),
            userID: parseInt(fieldUserMapping.userID),
            allowDivisionID: parseInt(fieldUserMapping.allowDivisionID)
        }, { abortEarly: false });

        if (error) {
            let newErrors = {};
            error.details.forEach(err => {
                newErrors[err.path[0]] = err.message;
            });
            setErrors(newErrors);
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "Please fill all required fields"
            });

            setTimeout(() => {
                setMessageModel(prev => ({
                    ...prev,
                    hidden: true
                }));
            }, 5000);

            return;
        }

        let detailsObject = {
            groupID: parseInt(fieldUserMapping.groupID.toString()),
            operationEntityID: parseInt(fieldUserMapping.operationEntityID.toString()),
            collectionPointID: parseInt(fieldUserMapping.collectionPointID.toString()),
            userID: parseInt(fieldUserMapping.userID.toString()),
            allowDivisionID: parseInt(fieldUserMapping.allowDivisionID.toString()),
        };

        let detail = [];
        detail = details.dataArray;

        if (fieldUserMapping.userID !== "0") {
            const existsInArray = detail.some(item =>
                item.userID === detailsObject.userID &&
                item.allowDivisionID === detailsObject.allowDivisionID
            );

            if (existsInArray) {
                setMessageModel({
                    ...messageModel,
                    hidden: false,
                    type: "Warning",
                    disciption: `User is already mapped to division: ${allowDivisions[fieldUserMapping.allowDivisionID]}`
                });

                setTimeout(() => {
                    setMessageModel(prev => ({
                        ...prev,
                        hidden: true
                    }));
                }, 4000);

                return;
            }

            const validationResponse = await services.CheckFieldUserMappingExists(
                detailsObject.userID,
                detailsObject.allowDivisionID
            );

            if (validationResponse.statusCode === "Error") {
                setMessageModel({
                    ...messageModel,
                    hidden: false,
                    type: "Error",
                    disciption: validationResponse.message
                });

                setTimeout(() => {
                    setMessageModel(prev => ({
                        ...prev,
                        hidden: true
                    }));
                }, 5000);

                return;
            }

            let userDetailsListArray = {
                groupID: detailsObject.groupID,
                operationEntityID: detailsObject.operationEntityID,
                collectionPointID: detailsObject.collectionPointID,
                userID: detailsObject.userID,
                allowDivisionID: detailsObject.allowDivisionID,
                divisionName: allowDivisions[fieldUserMapping.allowDivisionID],
                userName: users[fieldUserMapping.userID]
            };
            detail.push(userDetailsListArray);

            setDetails({
                ...details,
                dataArray: detail
            });
            checkTableVisibility();
        }
    }


    async function handleAllDataSave(e) {
        e.preventDefault()
        const saveData = details.dataArray.map(x => ({
            userID: parseInt(x.userID),
            allowDivisionID: parseInt(x.allowDivisionID),
            createdBy: parseInt(tokenService.getUserIDFromToken())
        }));
        const response = await services.FieldUserMappingSave(saveData)
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                props.history.push({ pathname: '/FieldUserMapping' })
            }, 1500);
        }
    }

    const removeDetailByIndex = (index) => {
        let tempArray = details.dataArray;
        const filteredArray = tempArray.filter((obj, idx) => {
            return (idx !== index)
        })
        setDetails({
            dataArray: filteredArray
        });
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getUsers() {
        const result = await services.getUsers(fieldUserMapping.collectionPointID);
        setUsers(result)
    }

    async function getDevisions() {
        const result = await services.getDivisions(fieldUserMapping.operationEntityID)
        setDevisions(result)
    }

    async function getAllowDivisions() {
        const result = await services.getDivisions(fieldUserMapping.operationEntityID)

        if (fieldUserMapping.collectionPointID && fieldUserMapping.collectionPointID !== "0") {
            const filteredResult = {};
            for (const [key, value] of Object.entries(result)) {
                if (key !== fieldUserMapping.collectionPointID.toString()) {
                    filteredResult[key] = value;
                }
            }
            setAllowDivisions(filteredResult)
        } else {
            setAllowDivisions(result)
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function checkTableVisibility() {
        if (fieldUserMapping.userID === '0') {
            setIsViewTable(true);
        } else {
            setIsViewTable(false);
        }
    }

    function clearButton() {
        setErrors({});
        var token = tokenService.getUserDetailsFromToken();
        setFieldUserMapping({
            ...fieldUserMapping,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: '0',
            userID: '0',
            allowDivisionID: '0'
        });
        setDetails({
            dataArray: []
        });
        setIsViewTable(true);
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Add"
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/FieldUserMapping"
                                />
                            </div>
                            <form>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={fieldUserMapping.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={fieldUserMapping.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.fromEntries(
                                                    Object.entries(operationEntities).filter(([key, value]) => {
                                                        if (key === "0" || !value) return false;
                                                        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                            return true;
                                                        }
                                                        return Object.values(multipleEstates).includes(value);
                                                    })
                                                )
                                            )}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={fieldUserMapping.collectionPointID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(devisions)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="userID">User *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="userID"
                                            name="userID"
                                            value={fieldUserMapping.userID}
                                            disabled={details.dataArray.length > 0}
                                            onChange={(e) => handleUserChange(e.target)}>
                                            <MenuItem value="0">--Select User--</MenuItem>
                                            {generateDropDownMenu(users)}
                                        </Select>
                                        {errors["userID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["userID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="allowDivisionID">Allow Collection Point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="allowDivisionID"
                                        name="allowDivisionID"
                                        value={fieldUserMapping.allowDivisionID}
                                        onChange={(e) => handleAllowDivisionChange(e.target)}>
                                        <MenuItem value="0">--Select Collection Point--</MenuItem>
                                        {generateDropDownMenu(allowDivisions)}
                                    </Select>
                                    {errors["allowDivisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["allowDivisionID"]}</FormHelperText>}
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        onClick={handleSave}
                                    />
                                </div>
                            </form>

                            <div className="table-responsive row-top-gap" hidden={isViewTable || details.dataArray.length === 0}>
                                <table className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Division Name</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {details.dataArray.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.divisionName}</td>
                                                <td>
                                                    <IconButton aria-label="delete" onClick={() => removeDetailByIndex(index)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Save"
                                        onClick={handleAllDataSave}
                                        hidden={details.dataArray.length === 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}